const LessonsIndex = () => import(/* webpackChunkName: "my-lessons" */ '@/pages/lessons/LessonsIndex')
const LessonsCalendarMonth = () => import(/* webpackChunkName: "my-lessons" */ '@/pages/lessons/LessonsCalendarMonth')
const LessonsCalendarWeek = () => import(/* webpackChunkName: "my-lessons" */ '@/pages/lessons/LessonsCalendarWeek')
const LessonsCalendarWeekPdf = () => import(/* webpackChunkName: "my-lessons" */ '@/pages/lessons/LessonsCalendarWeekPdf')
const LessonList = () => import(/* webpackChunkName: "my-lessons" */ '@/pages/lessons/LessonList')
const LessonsToReview = () => import(/* webpackChunkName: "my-lessons" */ '@/pages/lessons/LessonsToReview')
const AddNewLesson = () => import(/* webpackChunkName: "my-lessons" */ '@/pages/lessons/AddNewLesson')
const LessonsRecycleBin = () => import(/* webpackChunkName: "my-lessons" */ '@/pages/lessons/LessonsRecycleBin')

export default [
  {
    path: '/develop/my-lessons',
    name: 'LessonsIndex',
    component: LessonsIndex,
    redirect: { name: 'LessonsCalendarWeek' },
    children: [
      {
        path: 'calendar/month',
        name: 'LessonsCalendarMonth',
        component: LessonsCalendarMonth
      },
      {
        path: 'calendar/week',
        name: 'LessonsCalendarWeek',
        component: LessonsCalendarWeek,
        meta: {
          coursesWithLessons: []
        }
      },
      {
        path: 'calendar/week/pdf',
        name: 'LessonsCalendarWeekPdf',
        component: LessonsCalendarWeekPdf
      },
      {
        path: 'list',
        name: 'LessonList',
        component: LessonList
      },
      {
        path: 'review',
        name: 'LessonsToReview',
        component: LessonsToReview
      },
      {
        path: 'add-new-lesson',
        name: 'LessonsAddNewLesson',
        component: AddNewLesson
      },
      {
        path: 'recycle-bin',
        name: 'LessonsRecycleBin',
        component: LessonsRecycleBin
      }
    ]
  }
]
